import { motion, useReducedMotion } from "framer-motion";

/* B7: блок поднимается на 32px и проявляется за 700мс по базовой кривой, один раз.
   При reduce-motion остаётся только смена прозрачности. */
export const Reveal = ({ children, delay = 0, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-64px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};
